export const TAB_FORM_LIST = [
    {
        name: 'users',
        label: 'User Info',
    },
    {
        name: 'groups',
        label: 'Groups',
    },
    {
        name: 'devices',
        label: 'Devices',
        mode: 'edit',
    },
];
